import { useEffect, type FunctionComponent, type PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';
import { identify } from '@fff-web/fff-analytics';

const AnalyticsWrapper: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    identify();
  }, [location]);
  return children;
};

export default AnalyticsWrapper;
